/* unplugin-vue-components disabled */import script from "./inPageSubPage.vue?vue&type=script&lang=js"
export * from "./inPageSubPage.vue?vue&type=script&lang=js"

import "./inPageSubPage.vue?vue&type=style&index=0&id=246a2657&lang=scss"

const __exports__ = script;

export default __exports__